module.exports = __webpack_public_path__ + "static/media/foundationBooklets.23476481.png";